import { Draggable, Droppable } from '@hello-pangea/dnd';
import { Divider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { TaskItem } from '@/entities/task/ui';
import { DetailsDrawer } from '@/features/DetailsDrawer';
import { useTaskStore } from '@/features/Task';
import { useDetailsDrawer } from '@/hooks/useDetailsDrawer';

import s from './FavoriteTasks.module.scss';

type FavoriteTasksProps = {
  isDragging: boolean;
};

const FavoriteTasks: React.FC<FavoriteTasksProps> = observer(({ isDragging }) => {
  const { favoriteTasks } = useTaskStore();
  const { isOpen, selectedTask, showDetails, hideDetails, handleExited } = useDetailsDrawer();

  return (
    <>
      <div className={s.favoriteTasks}>
        <div className={s.favoriteTasks__header}>
          <h3>Избранные задачи</h3>
          <Divider />
        </div>
        <Droppable droppableId="favoriteTasks">
          {(provided) => (
            <div
              className={s.favoriteTasks__content}
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {isDragging && (
                <div className={s.favoriteTasks__cancelZone}>
                  <div className={s.favoriteTasks__cancelZone_content}>
                    <span>Отмена</span>
                  </div>
                </div>
              )}
              {favoriteTasks.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                      }}
                    >
                      <TaskItem task={item} onOpenDetails={showDetails} />
                    </div>
                  )}
                </Draggable>
              ))}
              {favoriteTasks.length === 0 && (
                <div className={s.favoriteTasks__empty}>
                  <p>
                    Нет избранных задач. Добавьте задачи в избранное через трекер, чтобы они
                    отображались здесь.
                  </p>
                </div>
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>

      <DetailsDrawer
        open={isOpen}
        onClose={hideDetails}
        onExited={handleExited}
        task={selectedTask}
      />
    </>
  );
});

export default FavoriteTasks;
